var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Stockreport "
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.searchFor')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-check-circle-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchforFlt),
      expression: "searchforFlt"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "days",
      "name": "days"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchforFlt = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changedate]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.selectSearchFor')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "order"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cluster"
    }
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterId')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "clusterdate"
    }
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterDate')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "orderdate"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.orderDate')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "clustercompleteddate"
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.clustercompleteddate')))])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.salesChannelPlaceholder')) + "  ")]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                          " + _vm._s(channel.saleschannel))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.clusterStatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchstatus),
      expression: "searchstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('pickingReport.orderStatusPlaceholder')) + "    ")]), _vm._v(" "), _vm._l((_vm.orderstatuslist), function(ordstatus) {
    return _c('option', {
      domProps: {
        "value": ordstatus.status
      }
    }, [_vm._v("\n                          " + _vm._s(ordstatus.status))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(this.searchforFlt == 'cluster') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('clusterPackingReport.clusterID'),
      "id": "searchClusterID"
    },
    on: {
      "keyup": _vm.validateorderid
    },
    model: {
      value: (_vm.searchClusterID),
      callback: function($$v) {
        _vm.searchClusterID = $$v
      },
      expression: "searchClusterID"
    }
  })], 1), _vm._v(" "), (_vm.SearchOrderidErr) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SearchOrderidErr))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.searchforFlt == 'clusterdate') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.clusterFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.ClusterfromDateFlt),
      callback: function($$v) {
        _vm.ClusterfromDateFlt = $$v
      },
      expression: "ClusterfromDateFlt"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.searchforFlt == 'clusterdate') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.clusterToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.ClustertoDateFlt),
      callback: function($$v) {
        _vm.ClustertoDateFlt = $$v
      },
      expression: "ClustertoDateFlt"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.searchforFlt == 'order') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.orderID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.orderIDPlaceholder')
    },
    model: {
      value: (_vm.Serchorderid),
      callback: function($$v) {
        _vm.Serchorderid = $$v
      },
      expression: "Serchorderid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.searchforFlt == 'orderdate') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.orderIDFromDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.OrderIDfromDateFlt),
      callback: function($$v) {
        _vm.OrderIDfromDateFlt = $$v
      },
      expression: "OrderIDfromDateFlt"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.searchforFlt == 'orderdate') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('clusterPackingReport.orderIDToDate')) + " :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.OrderIDtoDateFlt),
      callback: function($$v) {
        _vm.OrderIDtoDateFlt = $$v
      },
      expression: "OrderIDtoDateFlt"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-15px",
      "margin-left": "777px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getClusterReportDataSearch(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                      " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('clusterPackingReport.table.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('product.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1.5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listClusterPickCollapseData.length > 0) ? _c('div', {
    staticClass: "col-md-0.5"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-319px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listClusterPickCollapseData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-205px"
    },
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getClusterReportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.limitExeed && _vm.show && _vm.listClusterPickCollapseData.length) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-170px"
    },
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download Excel"
    },
    on: {
      "click": function($event) {
        _vm.getClusterReportDataForXls(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.limitExeed && _vm.show && _vm.listClusterPickCollapseData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-170px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listStockReportDataforxls,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }), _vm._v(" "), (_vm.checkflag == true) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterId')))]) : _vm._e(), _vm._v(" "), (_vm.checkflag == true) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterDate')))]) : _vm._e(), _vm._v(" "), (_vm.checkflag == true) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('editedjson.clustercompleteddate')))]) : _vm._e(), _vm._v(" "), (_vm.checkflag == false) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterId')))]) : _vm._e(), _vm._v(" "), (_vm.checkflag == false) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.clusterDate')))]) : _vm._e(), _vm._v(" "), (_vm.checkflag == false) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('editedjson.clustercompleteddate')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.totalSKU')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.totalQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.pickedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(" " + _vm._s(_vm.$t('clusterPackingReport.table.columns.pendingQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.pickerName')))])])]), _vm._v(" "), _c('tbody', [(_vm.client == '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientNoWarehouseMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client == '' && _vm.warehouse != '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noClientMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehouseSelectHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.warehouse != '' && _vm.searchforFlt != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noSearchBtnMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.warehouse != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.noRecordFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listClusterPickCollapseData), function(data) {
    return [_c('tr', {
      staticClass: "text-center "
    }, [_c('td', {
      class: {
        opened: _vm.opened.includes(data.clusterid)
      },
      staticStyle: {
        "padding": "5px",
        "color": "#0000e5",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showRow(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-down",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (data.orderid) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.orderid))]) : _vm._e(), _vm._v(" "), (data.orderid) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.orderdate))]) : _vm._e(), _vm._v(" "), (data.clusterid) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clusterid))]) : _vm._e(), _vm._v(" "), (data.clusterid) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clusterdate))]) : _vm._e(), _vm._v(" "), (data.clustercompleteddate == null || data.clustercompleteddate == '' || data.iscompleted != 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), (data.clustercompleteddate && data.iscompleted == 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clustercompleteddate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalsku))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pendingqty))]), _vm._v(" "), (data.iscompleted == 0) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Completed")]) : _vm._e(), _vm._v(" "), (data.iscompleted != 0 && data.iscompleted != data.totalqty) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("InProgress\n                    ")]) : _vm._e(), _vm._v(" "), (data.iscompleted == data.totalqty) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pickername))])]), _vm._v(" "), (data.contentVisible) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": 13
      }
    }, [_c('fieldset', {
      staticStyle: {
        "padding": "10px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-14"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('table', {
      staticClass: "table table-bordered mytable12",
      attrs: {
        "width": "100%"
      }
    }, [_c('thead', {
      staticClass: "theader"
    }, [_c('tr', {
      staticClass: "prod-list-table"
    }, [_c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.orderID')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.orderDate')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.merchant')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.totalQty')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.totalSKU')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.pickedQty')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('orders.nFQty')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.pendingQty')))]), _vm._v(" "), _c('th', {
      staticClass: "text-center "
    }, [_vm._v(_vm._s(_vm.$t('clusterPackingReport.table.columns.orderStatus')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.oneshipdetails), function(row) {
      return _c('tr', {
        staticClass: "prod-list-table"
      }, [_c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.orderid))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.orderdate))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.merchantname))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.totalqty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.totalsku))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.pickqty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.nfqty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.pendingqty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(row.orderstatus))])])
    }))])])])])])]) : _vm._e()]
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listClusterPickCollapseData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-773011cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773011cf","hasScoped":true}!./src/views/components/reports/clusterpickcollapse/clusterpickcollapse.component.html
// module id = 1848
// module chunks = 0